import { RoomTypes } from '~analytics/types';

import { sendLaunchSpaceRaceEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchSpaceRaceEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-space-race';
  protected amplitudeEventFunction = sendLaunchSpaceRaceEvent;

  constructor(settings: any, isRosteredRoom: boolean) {
    super();
    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
        activity_require_names: settings.require_names,
        activity_shuffle_questions: settings.random_questions,
        activity_shuffle_answers: settings.random_answers,
        activity_show_question_feedback: settings.show_feedback,
        activity_show_final_score: settings.show_results,
        activity_one_attempt: settings.one_attempt,
        spacerace_number_of_teams: settings.team_count,
        spacerace_icon: settings.icon_type,
        spacerace_countdown: settings.seconds > 0 ? settings.seconds : '',
        spacerace_team_assignment: settings.team_assignment_type,
      };
    } catch (err) {
      console.log('Error parsing analytics data', err);
    }
  }
}
